import { gql } from "@apollo/client";

export const REQUEST_ESTIMATE = gql`
  mutation (
    $description: String!
    $documents: [String!]
    $firstName: String!
    $telephone: String
    $lastName: String!
    $email: String!
    $token: String!
  ) {
    requestEstimate(
      options: {
        description: $description
        telephone: $telephone
        documents: $documents
        firstName: $firstName
        lastName: $lastName
        email: $email
        acceptedTerms: true
        token: $token
      }
    ) {
      errors {
        message
      }
      data {
        id
      }
    }
  }
`;

export const UPDATE_ESTIMATE_STATUS = gql`
  mutation ($id: Int!, $status: SanitizedEstimatesEnumType!) {
    updateEstimateStatus(options: { id: $id, status: $status }) {
      errors {
        message
      }
      message
    }
  }
`;

export const UPDATE_ESTIMATE_STATUS_BY_ACCESS_TOKEN = gql`
  mutation ($accessToken: String!) {
    updateEstimateByAccessToken(accessToken: $accessToken) {
      errors {
        message
      }
      message
    }
  }
`;

export const UPDATE_ESTIMATE_MESSAGE_STATUS = gql`
  mutation ($id: Int!) {
    updateEstimateMessageStatus(id: $id) {
      errors {
        message
      }
      message
    }
  }
`;

export const UPDATE_ESTIMATE_AS_READ = gql`
  mutation ($id: Int!) {
    updateStatusOfUnreadEstimate(id: $id) {
      errors {
        message
      }
      data {
        status
      }
    }
  }
`;

export const UPDATE_ESTIMATE_AS_READ_BY_ACCESS_TOKEN = gql`
  mutation ($accessToken: String!) {
    updateStatusOfUnreadEstimateUsingAccessToken(accessToken: $accessToken) {
      errors {
        message
      }
      data {
        status
      }
    }
  }
`;
